"use strict";

import mouse from "./services/mouseAction";
import observer from "./services/observer";
import mailer from "./services/forms";
import scrolling from "./services/scrolling";
import { hamburgerAct, hideBigMenu } from "./modules/menuBig";
import { showBigMenu } from "./modules/menuBig";
import { modalOpen, modalClose } from "./modules/modal";
import { loadData, dataObj } from "./services/loadData";
import createSliderWithRange from "./modules/slider";
import filterData from "./services/filterData";
import resize from "./services/resize";
import bigImage from "./modules/bigImg";
import { overlayBlock } from "./services/variables";

import cookies from "./modules/coockies";

window.addEventListener("DOMContentLoaded", () => {
	observer();
	mailer();

	window.addEventListener("scroll", scrolling);

	function eventListener(action) {
		window.addEventListener(action, (e) => {
			if (e.target.classList.contains("button")) {
				modalOpen("overlay-modal__active", "modal__active");
			} else if (
				e.target.classList.contains("modal__close") ||
				e.target.classList.contains("overlay-modal")
			) {
				modalClose("overlay-modal__active", "modal__active");
			} else if (e.target.closest(".brendy__slider_slide")) {
				const parrent = e.target.closest(".brendy__slider_slide");
				const letterContent = parrent.querySelector(
					".brendy__slider_slide-letter",
				).textContent;
				filterData(letterContent, dataObj);
			} else if (e.target.closest(".button__Category") && innerWidth >= 768) {
				console.log(1);
				showBigMenu("top", "scroll", "transform");
			} else if (e.target.closest(".menuBig__close")) {
				hideBigMenu("top", "scroll");
			} else if (e.target.closest(".photo__img")) {
				bigImage(e);
			} else if (e.target.closest(".photo__overlay_close")) {
				overlayBlock.classList.remove("photo__overlay_active");
			} else if (e.target.classList.contains("photo__overlay")) {
				overlayBlock.classList.remove("photo__overlay_active");
			} else if (e.target.closest(".hamburger")) {
				hamburgerAct(
					"transform__translateX",
					"hidden__letter",
					"hamburger__cross",
				);
			} else if (e.target.closest(".menuTop__items_link")) {
				hamburgerAct(
					"transform__translateX",
					"hidden__letter",
					"hamburger__cross",
				);
				if (e.target.closest(".button__Category")) {
					showBigMenu("top", "scroll", "transform");
				}
			}
		});
	}

	eventListener("pointerdown");

	loadData("data.json");

	const letters = Array.from({ length: 26 }, (_, i) =>
		String.fromCharCode(65 + i),
	);

	const sliderItems = document.querySelectorAll(".itc-slider-item");

	sliderItems.forEach((item, i) => {
		let startIndex = i * 9;
		let endIndex = Math.min(startIndex + 9, letters.length);

		const slider = createSliderWithRange(letters, startIndex, endIndex);

		item.appendChild(slider);
	});
	mouse(
		document.querySelectorAll(".brendy__slider_slide"),
		document.querySelectorAll(".brendy__slider_slide-overlay"),
		document.querySelectorAll(".brendy__slider_slide-overlayBlack"),
		document.querySelectorAll(".brendy__slider_slide-border"),
		document.querySelectorAll(".brendy__slider_slide-letterSmall"),
		document.querySelectorAll(".brendy__slider_slide-letter"),
	);
	resize();
	window.addEventListener("resize", resize);

	cookies();
});
